import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {suitesFeatureKey, SuitesState} from "./suites.reducer";

export const getSuitesState = createFeatureSelector<SuitesState>(suitesFeatureKey);

export const getSuites = createSelector(getSuitesState, (state) => state.data);
export const getSuitesLoading = createSelector(getSuitesState, SelectorUtil.isLoading);
